/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactNode, SetStateAction } from "react";

import { useTranslation } from "react-i18next";

import { ICON_DEFAULT_STYLE } from "@/shared/constants";

import { MoreVertIcon } from "@dotnet/telematics-design-system";

import Button from "../../../components/Button/Button";
import Menu from "../../../components/Menu/Menu";
import Tooltip from "../../../components/Tooltip/Tooltip";
import { MenuAnchorEl } from "../../types";

interface MoreActionsButtonProps {
  onMenuOpen: (e: {
    currentTarget: SetStateAction<MenuAnchorEl>;
    stopPropagation: () => void;
  }) => void;
  anchorEl: MenuAnchorEl;
  onCloseMenu: () => void;
  children: ReactNode;
  menuWidth?: string;
  customStyle?: any;
}

const MoreActionsButton = ({
  onMenuOpen,
  anchorEl,
  onCloseMenu,
  children,
  menuWidth,
  customStyle
}: MoreActionsButtonProps) => {
  const { t } = useTranslation();

  return (
    <div css={css(customStyle)}>
      <Tooltip title={t("Actions##actions")} placement="top" size="medium">
        <Button
          data-testid="more-actions-menu-button"
          aria-hidden="false"
          size="tiny"
          variant="iconOnly"
          color="secondary"
          icon={<MoreVertIcon style={ICON_DEFAULT_STYLE} />}
          onClick={onMenuOpen}
          css={css({ backgroundColor: "transparent" })}
        />
      </Tooltip>

      <Menu
        variant="menu"
        data-testid="more-actions-menu"
        open={Boolean(anchorEl)}
        onClose={onCloseMenu}
        anchorEl={anchorEl}
        slotProps={{ list: { disableListWrap: true } }}
        css={css({
          "& .MuiMenu-paper": {
            width: menuWidth ?? "211px"
          }
        })}
      >
        <div>{children}</div>
      </Menu>
    </div>
  );
};

export default MoreActionsButton;
